import type { JoinRequestMirror, JoinRequestStatus } from './orgs.types';

const STATUSES: readonly JoinRequestStatus[] = ['pending', 'approved', 'declined', 'withdrawn'];

/** Reads `users/{uid}.joinRequest` defensively: anything malformed is null. */
export function parseJoinRequest(raw: unknown): JoinRequestMirror | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const { orgId, orgName, status } = raw as Record<string, unknown>;
  if (typeof orgId !== 'string' || orgId.length === 0 || typeof orgName !== 'string') {
    return null;
  }
  const known = STATUSES.find((s) => s === status);
  return known ? { orgId, orgName, status: known } : null;
}
